import { createAsyncThunk } from '@reduxjs/toolkit'
import { NftStatItems } from '../type'
import { AppState } from 'state'

const fetchNftStatBySlug = createAsyncThunk<{ items: NftStatItems }, string, { state: AppState }>(
  'nftstat/getBySlug',
  async (slug, thunkApi) => {
    const { filter } = thunkApi.getState().nftstat
    const res = await fetch(`${process.env.REACT_APP_NFT_STATS_API_URL}/nftstat/${slug}/${filter}`)
    const data = await res.json()
    let items = thunkApi.getState().nftstat.items

    items = {
      ...items,
      [slug]: {
        ...items?.[slug],
        ...data,
        days: {
          ...items?.[slug]?.days,
          [filter]: data.days
        }
      }
    }

    return { items }
  }
)

export default fetchNftStatBySlug
